import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs';

import { OptionSheetViewActions } from '../sheet-view-core/sheet-view.actions';
import { sheetViewStateSelector } from '../sheet-view-core/sheet-view.state';
import { OptionSheetViewService } from './option-sheet-view.service';

@Injectable()
export class SheetViewEffects {
    constructor(
        private actions$: Actions,
        private store: Store,
        private optionSheetViewService: OptionSheetViewService,
    ) {}

    onOpenSheetView$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(OptionSheetViewActions.openOptionSheetView),
                tap((action) => {
                    this.optionSheetViewService.openSheetView(action.payload);
                }),
            );
        },
        { dispatch: false },
    );

    onUpdateSheetView$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(OptionSheetViewActions.updateOptionSheetView),
                concatLatestFrom(() => this.store.select(sheetViewStateSelector)),
                tap(([action, currentState]) => {
                    if (
                        !action.payload.sourceOptionGroup ||
                        (action.payload.sourceOptionGroup && currentState.optionGroupId === action.payload.sourceOptionGroup?.id)
                    ) {
                        this.optionSheetViewService.updateSheetView(action.payload);
                    }
                }),
            );
        },
        { dispatch: false },
    );
}
